import { Box, Button, Typography } from '@mui/material';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

export const useHasOperationSettings = () => {
  const [{ operationSettings }] = useCookies(['operationSettings']);
  return !!(
    operationSettings?.defaultLocation?.key &&
    operationSettings?.defaultZone?.key
  );
};

const RequireOperationSettings = ({ children }) => {
  const hasOperationSettings = useHasOperationSettings();
  const navigate = useNavigate();

  if (!hasOperationSettings) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          width: '100%',
          minHeight: '300px',
          textAlign: 'center',
        }}
      >
        <Typography>
          جهت مشاهده این صفحه ابتدا باید تنظیمات پیش فرض انبار را انتخاب کید.
        </Typography>
        <Button
          onClick={() => navigate('/operation/default-settings')}
          variant="contained"
        >
          رفتن به تنظیمات
        </Button>
      </Box>
    );
  }

  return children;
};

export default RequireOperationSettings;
